import { RoutePath } from 'src/router/routePath';
import { RoleType } from 'src/enums/RoleType';
import IconSystemAdminUsers from 'src/assets/icons/SidebarIcons/user.svg';
import IconOrder from 'src/assets/icons/SidebarIcons/order.svg';
import IconProject from 'src/assets/icons/SidebarIcons/project.svg';
import IconEstimate from 'src/assets/icons/SidebarIcons/estimate.svg';
import IconContract from 'src/assets/icons/SidebarIcons/contract.svg';
import IconBilling from 'src/assets/icons/SidebarIcons/billing.svg';

export const MenuPartner = [
  {
    key: RoutePath.PARTNER_PROJECT,
    label: 'プロジェクト管理',
    icon: IconProject,
    middleware: [RoleType.PARTNER],
  },
  {
    key: RoutePath.PARTNER_ESTIMATE,
    label: '見積管理',
    icon: IconEstimate,
    middleware: [RoleType.PARTNER],
  },
  {
    key: RoutePath.PARTNER_ORDER,
    label: '発注管理',
    icon: IconOrder,
    middleware: [RoleType.PARTNER],
  },
  {
    key: RoutePath.PARTNER_BILLING,
    label: '請求管理',
    icon: IconBilling,
    middleware: [RoleType.PARTNER],
  },
  {
    key: RoutePath.PARTNER_CONTRACT,
    label: '契約書管理',
    icon: IconContract,
    middleware: [RoleType.PARTNER],
  },
  {
    key: RoutePath.PARTNER_USER,
    label: 'ユーザー管理',
    icon: IconSystemAdminUsers,
    middleware: [RoleType.PARTNER],
  },
];
